export const TMCClientParameters = {

  FEATURES_BASIC_ONLY: 'clientproperty.yard.feature.basic-only',
  FEATURES_COMBINED_LEAVE: 'features.combined_leave',
  FEATURES_COMBINED_ENTRANCE: 'features.combined_entrance',
  FEATURES_SERVICE_VEHICLE: 'features.service-vehicles',
  FEATURES_SHUTTLE_TRANSPORTS: 'features.shuttle-transports',
  FEATURES_LINK_TRANSPORTS: 'features.link-transports',
  FEATURES_UMBRUECKUNG: 'features.umbrueckung',
  FEATURES_ISSUES: 'features.issues',

  UI_COMPONENT_REGISTER_ENTRANCE_WEIGHING_ENABLED: 'ui-component.register-entrance.weighing.enabled',
  UI_COMPONENT_REGISTER_LEAVE_WEIGHING_ENABLED: 'ui-component.register-leave.weighing.enabled',

  P_STATION_ASSIGNMENT_CLIENT_ORDERREFERENCE_ENABLED: 'station-assignment-client.orderreference.enabled',
  P_VISITS_ATTACH_DETACH_ENABLED: 'clientproperty.visitors.feature_enablement.attach_detach',
  P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED: 'clientproperty.visitors.feature_enablement.attach_detach.swap_trailer',
  P_VISITS_WEIGHING_ENABLED: 'clientproperty.visitors.feature_enablement.weighing',
  P_VISITS_TRANSPORT_AUTO_SELECT_SINGLE_SEARCH_RESULT: 'clientproperty.visitors.transport.feature_enablement.select_single_search_result',
  P_VISITS_TRANSPORT_COLUMNS: 'clientproperty.visitors.transport.columns',
  P_VISITS_TRANSPORT_REGISTER_SEARCH_VALUE_DESTINATION: 'clientproperty.visitors.transport.searchvalue.destination',
  P_VISITS_PERSONAL_VISIT_AUTO_SELECT_SINGLE_SEARCH_RESULT: 'clientproperty.visitors.personal_visit.feature_enablement.select_single_search_result',
  P_VISITS_PERSONAL_VISIT_COLUMNS: 'clientproperty.visitors.personal_visit.columns',
  P_VISITS_TRUCKS_COLUMNS: 'clientproperty.trucks.columns',
  P_DISPLAY_STATION_STATUS_DETAILS: 'display-station-status.details',
  P_VISITS_PERSONAL_VISIT_REGISTER_SEARCH_VALUE_DESTINATION: 'clientproperty.visitors.personal_visit.searchvalue.destination',
  P_VISITOR_REGISTRATION_LIST_VISITOR_COLUMNS: 'visitor-registration.list.visitors.columns',
  P_VISITOR_REGISTRATION_OVERVIEW_COLUMNS: 'visitor-registration.list.overview.columns',

  P_VISITOVERVIEW_REGISTER_REGISTER_ENTRANCE_VALUE: 'visitoverview.register.register.entrance.value',

  P_VISITOVERVIEW_REGISTER_LEAVE_MINLENGHT_WEIGHT: 'visitoverview.register.leave.minlength.weight',
  P_VISITOVERVIEW_REGISTER_ENTRANCE_MINLENGHT_WEIGHT: 'visitoverview.register.entrance.minlength.weight',
  P_YARDVIEW_STATIONS_NUMBER_PLATE_ENABLED: 'yardview.stations.numberplate.enabled',

};



